module.exports = __webpack_public_path__ + "static/pakmaya-gida-sertifikasi-ecd6b889f5e3386d58b833e836fc2777.png";